<template>
  <div ref="scene" id="scene">
    <slot></slot>
  </div>
</template>

<script>
  import Parallax from 'parallax-js'

  export default {
    name: 'Parallax',
    mounted () {
      var scene = this.$refs.scene;

      var parallaxInstance = new Parallax(scene, {
        scalarY: 3
      });
    }
  }

</script>
